import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

function FormBlogs__Meta(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Meta Title"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Meta Title"} // placeholder for the input
                formikFieldName={"blogMetaTitle"} // important: formik value name for the input
            />


            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Meta Description"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"Meta Description"} // placeholder for the input
                formikFieldName={"blogMetaDescription"} // important: formik value name for the input
            />
        </React.Fragment>
    )
}


export default memo(FormBlogs__Meta)